// extracted by mini-css-extract-plugin
module.exports = {"nft":"index_nft__y3gGq","dot":"index_dot__gaHOO"};